import { render } from "./GanttTab.vue?vue&type=template&id=9507297c&scoped=true&ts=true"
import script from "./GanttTab.vue?vue&type=script&lang=ts"
export * from "./GanttTab.vue?vue&type=script&lang=ts"

import "./GanttTab.vue?vue&type=style&index=0&id=9507297c&scoped=true&lang=scss"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9507297c"]])

export default __exports__